import manage from './manage';
import list from './list';

export default [...list, ...manage];
